import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@epicuro-next/platform/tracking';
import { EffectsModule } from '@ngrx/effects';

import { EcommerceTrackingEffects } from './effects/ecommerce-tracking.effects';
import { TrackingEffects } from './effects/tracking.effects';

@NgModule({
  imports: [
    CommonModule,
    TrackingModule,
    EffectsModule.forFeature([TrackingEffects, EcommerceTrackingEffects]),
  ],
})
export class StateTrackingModule {}
